export default {
  breadcrumb_home: 'Strona główna',
  breadcrumb_article: 'Kakobuy Spreadsheet',
  article_date: 'Data publikacji',
  article_update: 'Ostatnia aktualizacja',
  article_read_time: 'Czas czytania',
  article_minutes: 'min',
  article_share: 'Udostępnij',
  article_cta: 'Przejdź do głównego serwisu',
  article_cta_secondary: 'Zobacz wszystkie kategorie',
  article_disclaimer: 'Zastrzeżenie: Ta strona jest niezależnym przewodnikiem i nie jest bezpośrednio powiązana z platformą Kakobuy. Zawsze sprawdzaj informacje o sprzedawcach i produktach przed dokonaniem zakupu.',
  faq_title: 'Często zadawane pytania',
  related_articles: 'Powiązane artykuły',
};